import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Cards from "./Card";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@mui/material";
import axios from "axios";
import { API_URL } from "../API/config";
import { message } from "antd";

const Brought = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [data, setData] = useState<any[]>([]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const boughtTogether = queryParams.get("boughtTogether")?.split(",") || [];



  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  const getProduct = async () => {
  const token = sessionStorage.getItem("token"); 
           if(!token){
             message.error("Login required!") 
             return
           }  
             try {
      // Check if boughtTogether has items
      if (boughtTogether.length) {
        const requests = boughtTogether.map((val) =>
          axios.get(`${API_URL}/api/products/getById/${val}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
        );

        // Wait for all requests to complete
        const responses = await Promise.all(requests);
        // Process the response data
        const products = responses.map((response) => response.data);
        setData(products);
      }
    } catch (error: any) {
      // Handle error, if any
      errormessage(
        error.response?.data?.message || "Failed to fetch products."
      );
    }
  };

  useEffect(() => {
    getProduct();
  }, []);

  return (
    <>
      {contextHolder}
      <section
        className="pb-4"
        style={{ paddingTop: "6rem", overflowX: "hidden" }}
      >
        <Container>
          <div>
            <h2 className="head-txt-1 text-center w-100">
              <span>Bought</span> Together
            </h2>
          </div>
          <div className="row py-3">
            <Cards product={data} />
          </div>
          <div>
            <div className="text-end">
              <Link to="/cart">
                <Button variant="outlined" className="me-2 skipbtn">
                  Skip
                </Button>
              </Link>
              <Link to="/cart">
                <Button variant="outlined" className="skipbtn">
                  Continue
                </Button>
              </Link>
            </div>
          </div>
        </Container>
      </section>
      {/* <section
        style={{ boxShadow: "0px -2px 10px 0px #00000040" }}
        className="py-3"
      >
        <Container>
          <div className="">
            <div className="row">
              <div className="col-lg-1 col-md-1 col-sm-2 col-2">
                <div>
                  <img
                    className="img-fluid"
                    src="/assets/phone 1.png"
                    style={{
                      width: "84px",
                      height: "100px",
                      objectFit: "contain",
                      maxWidth: "85px",
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-sm-10 col-10">
                <div>
                  <h2 className="price-single">
                    Samsung Galaxy A15 5G (8G , 256 GB , Black )
                  </h2>
                  <p className="mb-0">
                    <span
                      className="me-2"
                      style={{
                        textDecoration: "line-through",
                        color: "#6C6C6C",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      ₹ 20,499.00
                    </span>
                  </p>
                  <h2 className="price-single">
                    ₹ 19,499.00 <span>(Include all taxes)</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center">
                <div className="sing-para text-center">
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                  >
                    Clear all
                  </span>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-lg-1 col-md-1 col-sm-2 col-2">
                <div>
                  <img
                    className="img-fluid"
                    src="/assets/phone 1.png"
                    style={{
                      width: "84px",
                      height: "100px",
                      objectFit: "contain",
                      maxWidth: "85px",
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-sm-10 col-10">
                <div>
                  <h2 className="price-single">
                    Samsung Galaxy A15 5G (8G , 256 GB , Black )
                  </h2>
                  <p className="mb-0">
                    <span
                      className="me-2"
                      style={{
                        textDecoration: "line-through",
                        color: "#6C6C6C",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      ₹ 20,499.00
                    </span>
                  </p>
                  <h2 className="price-single">
                    ₹ 19,499.00 <span>(Include all taxes)</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-12 d-flex justify-content-center align-items-center">
                <div className="sing-para text-center">
                  <Button>Buy Now</Button>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section> */}
    </>
  );
};

export default Brought;
